<div
    class="accordion"
    [class.accordion-flush]="flush"
    [class.accordion-widget]="widget"
>
    <ng-content></ng-content>
</div>
